//-----------------------------------------------------------
// 1. Produktseite – Mindestmenge setzen
//-----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  function initMinQty() {

    const minQty = window.productMinQty || window.minQty || 1;
    if (minQty <= 1) return;

    const productForm = document.querySelector("product-form");
    if (!productForm) {
      setTimeout(initMinQty, 300);
      return;
    }

    const qtyInput = productForm.querySelector('input[name="quantity"]');
    const addToCartForm = productForm.querySelector('form[action*="/cart/add"]');

    if (!qtyInput || !addToCartForm) {
      setTimeout(initMinQty, 300);
      return;
    }

    qtyInput.min = minQty;
    qtyInput.value = minQty;

    qtyInput.addEventListener("change", function () {
      if (parseInt(this.value) < minQty) {
        alert("Die Mindestabnahmemenge beträgt " + minQty + " Stück.");
        this.value = minQty;
      }
    });

    addToCartForm.addEventListener("submit", function (e) {
      if (parseInt(qtyInput.value) < minQty) {
        e.preventDefault();
        alert("Bitte mindestens " + minQty + " Stück auswählen.");
        qtyInput.value = minQty;
      }
    });

    console.log("✅ Mindestmenge aktiviert:", minQty);
  }

  initMinQty();
  document.addEventListener("shopify:section:load", initMinQty);
});


//-----------------------------------------------------------
// 2. Mini Cart + Drawer – Mindestmenge erzwingen
//-----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {

  const minQty = window.productMinQty || window.minQty;
  if (!minQty) return;

  function enforceMinQty(input) {
    if (!input) return;
    if (parseInt(input.value, 10) < minQty) {
      input.value = minQty;
      input.classList.add("minqty-shake");
      setTimeout(() => input.classList.remove("minqty-shake"), 300);
    }
  }

  function bindMinusButtons(context) {
    const minusButtons = context.querySelectorAll('button[name="minus"]');

    minusButtons.forEach(btn => {
      btn.addEventListener("click", function (e) {
        const input = btn.parentElement.querySelector("input");
        if (!input) return;
        const current = parseInt(input.value, 10);
        if (current <= minQty) {
          e.preventDefault();
          input.value = minQty;
        }
      });
    });
  }

  function bindInputs(context) {
    const inputs = context.querySelectorAll("input[type='number']");
    inputs.forEach(input => {
      input.addEventListener("change", function () {
        enforceMinQty(input);
      });
    });
  }

  const cartRoot = document.querySelector("form[action='/cart']");
  if (cartRoot) {
    bindMinusButtons(cartRoot);
    bindInputs(cartRoot);
  }

  document.addEventListener("cart:updated", function () {
    const drawer = document.querySelector("cart-drawer, #CartDrawer, .cart-drawer");
    if (!drawer) return;
    bindMinusButtons(drawer);
    bindInputs(drawer);
  });
});


//-----------------------------------------------------------
// 3. Main Cart – vor Shopify onchange blockieren
//-----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {

  const minQty = window.productMinQty || window.minQty;
  if (!minQty) return;

  console.log("Main Cart Mindestmenge aktiv:", minQty);

  function bindCartMain() {
    const cartRows = document.querySelectorAll("tr.cart-item");

    cartRows.forEach(row => {
      const qtyInput = row.querySelector(".quantity__input");
      const minusBtn = row.querySelector('button[name="minus"]');
      const plusBtn  = row.querySelector('button[name="plus"]');

      if (!qtyInput) return;

      qtyInput.addEventListener("change", function (e) {
        if (parseInt(this.value, 10) < minQty) {
          e.preventDefault();
          this.value = minQty;
          this.classList.add("minqty-shake");
          setTimeout(() => this.classList.remove("minqty-shake"), 300);
        }
      });

      if (minusBtn) {
        minusBtn.addEventListener("click", function (e) {
          let current = parseInt(qtyInput.value, 10);
          if (current <= minQty) {
            e.preventDefault();
            qtyInput.value = minQty;
            qtyInput.classList.add("minqty-shake");
            setTimeout(() => qtyInput.classList.remove("minqty-shake"), 300);
          }
        });
      }
    });
  }

  bindCartMain();
  document.addEventListener("cart:updated", bindCartMain);

});

//-----------------------------------------------------------
// 4. Shopify Dawn – Mindestmenge VOR updateQuantity blockieren
//-----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {

  const minQty = window.productMinQty || window.minQty;
  if (!minQty) return;

  // Fängt jede Änderung ab, BEVOR Shopify updateQuantity() ausführt
  document.addEventListener("change", function(e) {
    const input = e.target;

    // Nur echte Quantity-Felder
    if (!input.classList.contains("quantity__input")) return;

    const value = parseInt(input.value, 10);

    // Unter Mindestmenge? → Shopify-Request blockieren
    if (value < minQty) {
      e.stopImmediatePropagation();
      e.preventDefault();

      input.value = minQty;

      input.classList.add("minqty-shake");
      setTimeout(() => input.classList.remove("minqty-shake"), 300);
    }
  }, true);


  // Blockiert Minus-Klick, bevor Shopify reagiert
  document.addEventListener("click", function(e) {

    const btn = e.target.closest("button[name='minus']");
    if (!btn) return;

    const input = btn.parentElement.querySelector(".quantity__input");
    if (!input) return;

    const current = parseInt(input.value, 10);

    if (current <= minQty) {
      e.stopImmediatePropagation();
      e.preventDefault();

      input.value = minQty;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

  }, true);

});

//-----------------------------------------------------------
// Shopify Dawn – updateQuantity patchen (Main Cart Fix)
//-----------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  
  const minQty = window.productMinQty || window.minQty;
  if (!minQty) return;

  // Warten, bis CartItems class existiert
  const interval = setInterval(() => {
    const proto = customElements.get('cart-items')?.prototype;
    if (!proto || !proto.updateQuantity) return;

    clearInterval(interval);

    console.log("⚙️ Mindestmengen-Patch aktiv für Main Cart");

    // Original sichern
    const originalUpdate = proto.updateQuantity;

    // Überschreiben
    proto.updateQuantity = function(line, quantity, name) {
      const qty = parseInt(quantity, 10);

      // Mindestmenge abfangen
      if (qty < minQty) {
        console.warn("⛔ Mindestmenge verhindert:", minQty);
        quantity = minQty;

        // UI sofort korrigieren
        const input = document.getElementById(`Quantity-${line}`);
        if (input) input.value = minQty;
      }

      // Danach normal weitermachen
      return originalUpdate.call(this, line, quantity, name);
    };

  }, 100);
});